<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/name-icon.svg" alt="Prospectos" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Prospectos</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{selectedItem === 'recientes' ? 'Prospectos de hoy' : 'Todas las cuentas'}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todas las cuentas
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Prospectos de hoy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button  *ngIf="permissionService.hasPermission('Prospectos', 'Crear')" class="action-btn primary" (click)="openMdlCreateProspect()">
                            <img src="assets/svg/plus-icon.svg" alt="Añadir nuevo" width="16" height="16" />
                            Añadir nuevo
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{prospectosFiltrados.length}} elementos | Se actualizó hace 2 minutos</span>
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>
                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="!isLoading && prospectos.length > 0">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar por nombre, cargo, compañía, teléfono o email..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarProspectos()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                        
                                <button class="d-grid search-btn" (click)="openMdlCharts()">
                                    <img src="assets/svg/grafic-icon.svg" alt="Gráfica">
                                    <span>Ver gráfico</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>
                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th 
                                            (click)="sortByColumn('nombre')"
                                            [class.sorted]="sortColumn === 'nombre'"
                                            class="sortable-header"
                                        >
                                            Nombre
                                            <span *ngIf="sortColumn === 'nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('cargo')"
                                            [class.sorted]="sortColumn === 'cargo'"
                                            class="sortable-header"
                                        >
                                            Cargo
                                            <span *ngIf="sortColumn === 'cargo'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('empresa')"
                                            [class.sorted]="sortColumn === 'empresa'"
                                            class="sortable-header"
                                        >
                                            Compañía
                                            <span *ngIf="sortColumn === 'empresa'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('telefono')"
                                            [class.sorted]="sortColumn === 'telefono'"
                                            class="sortable-header"
                                        >
                                            Teléfono
                                            <span *ngIf="sortColumn === 'telefono'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('email')"
                                            [class.sorted]="sortColumn === 'email'"
                                            class="sortable-header"
                                        >
                                            Email
                                            <span *ngIf="sortColumn === 'email'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('estado')"
                                            [class.sorted]="sortColumn === 'estado'"
                                            class="sortable-header"
                                        >
                                            Estado prospecto
                                            <span *ngIf="sortColumn === 'estado'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th 
                                            (click)="sortByColumn('ejecutivo.nombre')"
                                            [class.sorted]="sortColumn === 'ejecutivo.nombre'"
                                            class="sortable-header"
                                        >
                                            Propietario
                                            <span *ngIf="sortColumn === 'ejecutivo.nombre'" class="sort-indicator">
                                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let prospecto of prospectosFiltrados; let i=index" [class.prospecto-invalido]="!prospecto.id"(click)="verDetalleProspecto(prospecto.id, $event)">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td>{{prospecto.nombre.charAt(0).toUpperCase() + prospecto.nombre.slice(1) + ' ' + prospecto.apellido.charAt(0).toUpperCase() + prospecto.apellido.slice(1)}}</td>
                                        <td>{{prospecto.cargo.charAt(0).toUpperCase() + prospecto.cargo.slice(1)}}</td>
                                        <td>{{prospecto.empresa.charAt(0).toUpperCase() + prospecto.empresa.slice(1)}}</td>
                                        <td>{{ '+569' + ' ' + prospecto.telefono }}</td>
                                        <td>{{prospecto.email}}</td>
                                        <td class="estado-cell">
                                            <span class="estado-badge estado-{{prospecto.estado?.toLowerCase().replace(' ', '-') || 'nuevo'}}">
                                                {{prospecto.estado || 'Nuevo'}}
                                            </span>
                                        </td>
                                        <td>{{prospecto.nombre.charAt(0)}}{{prospecto.apellido.split(' ')[0]}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + prospecto.id)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + prospecto.id">
                                                    <button *ngIf="permissionService.hasPermission('Prospectos', 'Editar')" class="dropdown-item" (click)="openManageProspect(prospecto)">Modificar</button>
                                                    <button *ngIf="permissionService.hasPermission('Prospectos', 'Eliminar')" class="dropdown-item" (click)="openMdlDeleteProspect(prospecto.prospecto_id)">Eliminar</button>
                                                    <button  class="dropdown-item" (click)="openNewChangeOwner(prospecto)">Cambiar propietario </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="!isLoading && prospectos.length === 0 && !errorMessage" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                <img src="assets/img/listaprospecto.png" alt="Lista de prospectos vacía" />
                            </div>
                            <h2>Sin prospectos por ahora</h2>
                            <p>Todavía no tienes prospectos registrados. Puedes comenzar agregando uno nuevo.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>